<div class="fill">
  <div class="main-area">
    @if(showLogin) {
      <div class="login-area">
        <img src="../../../assets/images/minerva/logo.webp" alt="Minerva logo" style="width: 150px;">
        <h1>{{ 'LOGIN.TEXT' | translate }}</h1>
        <form [formGroup]="form" class="form-area">
          <div class="form-input">
            <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.251 12.9829C14.5463 12.983 14.8388 13.0413 15.1116 13.1544C15.3844 13.2676 15.6322 13.4333 15.841 13.6423C16.0497 13.8512 16.2153 14.0992 16.3282 14.3721C16.4411 14.645 16.4991 14.9375 16.499 15.2329V15.8079C16.499 16.7019 16.179 17.5669 15.599 18.2459C14.029 20.0789 11.642 20.9839 8.496 20.9839C5.351 20.9839 2.964 20.0789 1.398 18.2439C0.818608 17.5652 0.500207 16.7022 0.5 15.8099V15.2319C0.5 14.6354 0.736947 14.0633 1.15872 13.6416C1.58049 13.2198 2.15253 12.9829 2.749 12.9829H14.251ZM14.251 14.4829H2.748C2.64947 14.4827 2.55189 14.502 2.46083 14.5397C2.36978 14.5773 2.28705 14.6326 2.21738 14.7022C2.14771 14.7719 2.09247 14.8546 2.05482 14.9457C2.01718 15.0367 1.99787 15.1343 1.998 15.2329V15.8099C1.998 16.3449 2.19 16.8629 2.538 17.2699C3.791 18.7389 5.758 19.4839 8.495 19.4839C11.234 19.4839 13.201 18.7389 14.458 17.2709C14.8066 16.8632 14.9982 16.3443 14.998 15.8079V15.2319C14.998 15.0334 14.9192 14.843 14.779 14.7026C14.6387 14.5621 14.4495 14.4831 14.251 14.4829ZM8.496 0.987854C9.15261 0.987854 9.80279 1.11718 10.4094 1.36846C11.016 1.61973 11.5672 1.98803 12.0315 2.45232C12.4958 2.91661 12.8641 3.46781 13.1154 4.07444C13.3667 4.68106 13.496 5.33124 13.496 5.98785C13.496 6.64446 13.3667 7.29464 13.1154 7.90127C12.8641 8.5079 12.4958 9.0591 12.0315 9.52339C11.5672 9.98768 11.016 10.356 10.4094 10.6073C9.80279 10.8585 9.15261 10.9879 8.496 10.9879C7.16992 10.9879 5.89815 10.4611 4.96047 9.52339C4.02278 8.58571 3.496 7.31394 3.496 5.98785C3.496 4.66177 4.02278 3.39 4.96047 2.45232C5.89815 1.51464 7.16992 0.987854 8.496 0.987854ZM8.496 2.48785C8.03637 2.48785 7.58125 2.57838 7.15661 2.75428C6.73197 2.93017 6.34613 3.18797 6.02113 3.51298C5.69612 3.83799 5.43831 4.22382 5.26242 4.64846C5.08653 5.0731 4.996 5.52823 4.996 5.98785C4.996 6.44748 5.08653 6.90261 5.26242 7.32725C5.43831 7.75189 5.69612 8.13772 6.02113 8.46273C6.34613 8.78773 6.73197 9.04554 7.15661 9.22143C7.58125 9.39732 8.03637 9.48785 8.496 9.48785C9.42426 9.48785 10.3145 9.1191 10.9709 8.46273C11.6273 7.80635 11.996 6.91611 11.996 5.98785C11.996 5.0596 11.6273 4.16936 10.9709 3.51298C10.3145 2.8566 9.42426 2.48785 8.496 2.48785Z" fill="#222222"/>
            </svg>
            <input formControlName="username" type="text" [placeholder]="'USER.LABEL' | translate">
          </div>
          <div class="form-input">
            <svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 15.1421C7.00272 15.1421 6.52581 14.9445 6.17418 14.5929C5.82254 14.2413 5.625 13.7644 5.625 13.2671C5.625 12.2265 6.45937 11.3921 7.5 11.3921C7.99728 11.3921 8.47419 11.5896 8.82582 11.9413C9.17746 12.2929 9.375 12.7698 9.375 13.2671C9.375 13.7644 9.17746 14.2413 8.82582 14.5929C8.47419 14.9445 7.99728 15.1421 7.5 15.1421ZM13.125 17.9546V8.57959H1.875V17.9546H13.125ZM13.125 6.70459C13.6223 6.70459 14.0992 6.90213 14.4508 7.25377C14.8025 7.6054 15 8.08231 15 8.57959V17.9546C15 18.4519 14.8025 18.9288 14.4508 19.2804C14.0992 19.632 13.6223 19.8296 13.125 19.8296H1.875C1.37772 19.8296 0.900805 19.632 0.549175 19.2804C0.197544 18.9288 0 18.4519 0 17.9546V8.57959C0 7.53896 0.834375 6.70459 1.875 6.70459H2.8125V4.82959C2.8125 3.58639 3.30636 2.3941 4.18544 1.51503C5.06451 0.63595 6.2568 0.14209 7.5 0.14209C8.11557 0.14209 8.72511 0.263336 9.29383 0.498905C9.86254 0.734473 10.3793 1.07975 10.8146 1.51503C11.2498 1.9503 11.5951 2.46705 11.8307 3.03576C12.0663 3.60447 12.1875 4.21402 12.1875 4.82959V6.70459H13.125ZM7.5 2.01709C6.75408 2.01709 6.03871 2.31341 5.51126 2.84085C4.98382 3.3683 4.6875 4.08367 4.6875 4.82959V6.70459H10.3125V4.82959C10.3125 4.08367 10.0162 3.3683 9.48874 2.84085C8.96129 2.31341 8.24592 2.01709 7.5 2.01709Z" fill="#222222"/>
            </svg>
            <input formControlName="currentPassword" [type]="showPassword ? 'text' : 'password'" [placeholder]="'USER.PASSWORD' | translate">
            <i class="material-icons notranslate eye-icon" (click)="toggleShowPassword()">{{ showPassword ? 'visibility_off' : 'visibility' }}</i>
          </div>
          <button type="submit" class="button red" (click)="submitForm()">
            {{ 'LOGIN.LABEL' | translate }}
          </button>
        </form>
        <a class="forgot-password" (click)="handleForgetPassword()">
          {{ 'FORGOT-PASSWORD.LABEL' | translate }}
        </a>
      </div>
    }
    @if (showChangePassword) {
      <div class="login-area" style="background: white; backdrop-filter: inherit; position: relative;">
        <button type="button" class="close-button" (click)="handleClickCloseRegister()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.7328 3.23965C15.3207 2.65177 15.3207 1.69864 14.7328 1.11077L14.4124 0.79038C13.8245 0.202508 12.8714 0.202508 12.2835 0.790381L7.76873 5.30517L3.25394 0.790382C2.66607 0.20251 1.71294 0.202508 1.12506 0.790381L0.804674 1.11077C0.216801 1.69864 0.216802 2.65177 0.804674 3.23965L5.31946 7.75444L0.804675 12.2692C0.216803 12.8571 0.216801 13.8102 0.804674 14.3981L1.12506 14.7185C1.71294 15.3064 2.66607 15.3064 3.25394 14.7185L7.76873 10.2037L12.2835 14.7185C12.8714 15.3064 13.8245 15.3064 14.4124 14.7185L14.7328 14.3981C15.3207 13.8102 15.3207 12.8571 14.7328 12.2692L10.218 7.75443L14.7328 3.23965Z" fill="#DB272D"/>
          </svg>
        </button>
        <img src="../../../assets/images/minerva/logo.webp" alt="Minerva logo" style="width: 150px;">
        <h1>{{ 'CHANGE-PASSWORD.LABEL' | translate }}</h1>
        <form [formGroup]="changePasswordForm" class="form-area">
          <div class="form-input">
            <input
              formControlName="newPassword"
              class="input-password"
              [type]="showPassword ? 'text' : 'password'"
              [placeholder]="'CHANGE-PASSWORD.FORM.NEW-PASSWORD' | translate"
            >
            <img
              [src]="
                showPassword
                  ? '../../../assets/images/login/olho_nao_exibi.png'
                  : '../../../assets/images/login/olho_exibi.png'
              "
              class="second-toggle-password-icon"
              (click)="toggleShowPassword()"
            />
          </div>
          <div class="form-input">
            <input
              formControlName="confirmNewPassword"
              class="input-password"
              [type]="showPassword ? 'text' : 'password'"
              [placeholder]="'CHANGE-PASSWORD.FORM.CONFIRM-PASSWORD' | translate"
            >
            <i class="material-icons notranslate eye-icon" (click)="toggleShowPassword()">{{ showPassword ? 'visibility_off' : 'visibility' }}</i>
          </div>
          @if (changePasswordForm.get('newPassword')?.touched && !changePasswordForm.get('newPassword')?.value && !changePasswordForm.get('confirmNewPassword')?.value && changePasswordForm.get('confirmNewPassword')?.touched) {
            <div class="warning">
              <i class="material-icons notranslate v-align"> report_problem </i>
              <p>{{ 'VALIDATORS.FILL-IN-ALL-FIELDS' | translate }}</p>
            </div>
          }
          @if (changePasswordForm.errors?.['passwordsMismatch']) {
            <div class="warning">
              <i class="material-icons notranslate v-align"> report_problem </i>
              <p>{{ 'VALIDATORS.PASSWORD-DO-NOT-MATCH' | translate }}</p>
            </div>
          }
          @if (changePasswordForm.get('newPassword')?.touched && changePasswordForm.get('newPassword')?.errors?.['passwordStrength']) {
            <div class="warning">
              <i class="material-icons notranslate v-align"> report_problem </i>
              <p>{{ 'VALIDATORS.PASSWORD-STRENGTH' | translate }}</p>
            </div>
          }
          <button type="submit" class="button red" (click)="submitChangePasswordForm()">
            {{ 'CHANGE-PASSWORD.LABEL' | translate }}
          </button>
        </form>
      </div>
    }
    @if (showForgotPassword) {
      <div class="login-area" style="background: white; backdrop-filter: inherit; position: relative;">
        <button type="button" class="close-button" (click)="handleClickCloseRegister()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.7328 3.23965C15.3207 2.65177 15.3207 1.69864 14.7328 1.11077L14.4124 0.79038C13.8245 0.202508 12.8714 0.202508 12.2835 0.790381L7.76873 5.30517L3.25394 0.790382C2.66607 0.20251 1.71294 0.202508 1.12506 0.790381L0.804674 1.11077C0.216801 1.69864 0.216802 2.65177 0.804674 3.23965L5.31946 7.75444L0.804675 12.2692C0.216803 12.8571 0.216801 13.8102 0.804674 14.3981L1.12506 14.7185C1.71294 15.3064 2.66607 15.3064 3.25394 14.7185L7.76873 10.2037L12.2835 14.7185C12.8714 15.3064 13.8245 15.3064 14.4124 14.7185L14.7328 14.3981C15.3207 13.8102 15.3207 12.8571 14.7328 12.2692L10.218 7.75443L14.7328 3.23965Z" fill="#DB272D"/>
          </svg>
        </button>
        <img src="../../../assets/images/minerva/logo.webp" alt="Minerva logo" style="width: 150px;">
        <h1>{{ 'FORGOT-PASSWORD.LABEL' | translate }}</h1>
        <p>{{ 'FORGOT-PASSWORD.TEXT' | translate }}</p>
        <form [formGroup]="resetPasswordForm" class="form-area">
          <app-generic-input
            [label]="'FORGOT-PASSWORD.FORM.EMAIL' | translate"
            [placeholder]="'FORGOT-PASSWORD.FORM.EMAIL' | translate"
            [control]="resetPasswordForm.get('email')"
            type="email"
          />
          <button type="submit" class="button red" (click)="submitResetPasswordForm()">
            {{ 'FORGOT-PASSWORD.SEND' | translate }}
          </button>
        </form>
      </div>
    }

    @if(doubleAuthentication) {
      <div class="login-area">
        <img src="../../../assets/images/minerva/logo.webp" alt="Minerva logo" style="width: 150px;">
        <h1>Autenticação</h1>
        <form [formGroup]="doubleAuthenticationForm" class="form-area">
          <div class="form-input">
           <i class="material-icons notranslate left-icon">key</i>
            <input
              formControlName="code"
              type="text"
              placeholder="Digite o código recebido via email"
            >
          </div>
          @if(!timeExpired) {
            <app-countdown (countdownFinished)="onCountdownFinished()"></app-countdown>
          }
          @if (doubleAuthenticationForm.get('code')?.touched && !doubleAuthenticationForm.get('code')?.value) {
            <div class="warning">
              <i class="material-icons notranslate v-align"> report_problem </i>
              <p>Informe o código antes de enviar!</p>
            </div>
          }
          <div class="container-button">
            <button type="submit" class="button green" (click)="submitDoubleAuthentication()">Enviar</button>
          </div>
        </form>
      </div>
    }
  </div>
</div>
